"use strict";
/* eslint-disable @typescript-eslint/naming-convention */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createImports = void 0;
var buffer_1 = require("./buffer");
var MsgPack = __importStar(require("@msgpack/msgpack"));
exports.createImports = function (config) {
    var memory = config.memory, state = config.state, client = config.client, abort = config.abort;
    return {
        w3: {
            __w3_subinvoke: function (uriPtr, uriLen, modulePtr, moduleLen, methodPtr, methodLen, inputPtr, inputLen) { return __awaiter(void 0, void 0, void 0, function () {
                var uri, moduleToInvoke, method, input, _a, data, error, msgpack;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // Reset our state
                            state.subinvoke.result = undefined;
                            state.subinvoke.error = undefined;
                            uri = buffer_1.readString(memory.buffer, uriPtr, uriLen);
                            moduleToInvoke = buffer_1.readString(memory.buffer, modulePtr, moduleLen);
                            method = buffer_1.readString(memory.buffer, methodPtr, methodLen);
                            input = buffer_1.readBytes(memory.buffer, inputPtr, inputLen);
                            state.subinvoke.args = [
                                uri,
                                moduleToInvoke,
                                method,
                                input,
                            ];
                            return [4 /*yield*/, client.invoke({
                                    uri: uri,
                                    module: moduleToInvoke,
                                    method: method,
                                    input: input,
                                    noDecode: true,
                                })];
                        case 1:
                            _a = _b.sent(), data = _a.data, error = _a.error;
                            if (!error) {
                                msgpack = void 0;
                                if (data instanceof ArrayBuffer) {
                                    msgpack = data;
                                }
                                else {
                                    msgpack = MsgPack.encode(data);
                                }
                                state.subinvoke.result = msgpack;
                            }
                            else {
                                state.subinvoke.error = error.name + ": " + error.message;
                            }
                            return [2 /*return*/, !error];
                    }
                });
            }); },
            // Give WASM the size of the result
            __w3_subinvoke_result_len: function () {
                if (!state.subinvoke.result) {
                    abort("__w3_subinvoke_result_len: subinvoke.result is not set");
                    return 0;
                }
                return state.subinvoke.result.byteLength;
            },
            // Copy the subinvoke result into WASM
            __w3_subinvoke_result: function (ptr) {
                if (!state.subinvoke.result) {
                    abort("__w3_subinvoke_result: subinvoke.result is not set");
                    return;
                }
                buffer_1.writeBytes(state.subinvoke.result, memory.buffer, ptr);
            },
            // Give WASM the size of the error
            __w3_subinvoke_error_len: function () {
                if (!state.subinvoke.error) {
                    abort("__w3_subinvoke_error_len: subinvoke.error is not set");
                    return 0;
                }
                return state.subinvoke.error.length;
            },
            // Copy the subinvoke error into WASM
            __w3_subinvoke_error: function (ptr) {
                if (!state.subinvoke.error) {
                    abort("__w3_subinvoke_error: subinvoke.error is not set");
                    return;
                }
                buffer_1.writeString(state.subinvoke.error, memory.buffer, ptr);
            },
            // Copy the invocation's method & args into WASM
            __w3_invoke_args: function (methodPtr, argsPtr) {
                if (!state.method) {
                    abort("__w3_invoke_args: method is not set");
                    return;
                }
                if (!state.args) {
                    abort("__w3_invoke_args: args is not set");
                    return;
                }
                buffer_1.writeString(state.method, memory.buffer, methodPtr);
                buffer_1.writeBytes(state.args, memory.buffer, argsPtr);
            },
            // Store the invocation's result
            __w3_invoke_result: function (ptr, len) {
                state.invoke.result = buffer_1.readBytes(memory.buffer, ptr, len);
            },
            // Store the invocation's error
            __w3_invoke_error: function (ptr, len) {
                state.invoke.error = buffer_1.readString(memory.buffer, ptr, len);
            },
            __w3_getImplementations: function (uriPtr, uriLen) {
                var uri = buffer_1.readString(memory.buffer, uriPtr, uriLen);
                var result = client.getImplementations(uri, {});
                state.getImplementationsResult = MsgPack.encode(result);
                return result.length > 0;
            },
            __w3_getImplementations_result_len: function () {
                if (!state.getImplementationsResult) {
                    abort("__w3_getImplementations_result_len: result is not set");
                    return 0;
                }
                return state.getImplementationsResult.byteLength;
            },
            __w3_getImplementations_result: function (ptr) {
                if (!state.getImplementationsResult) {
                    abort("__w3_getImplementations_result: result is not set");
                    return;
                }
                buffer_1.writeBytes(state.getImplementationsResult, memory.buffer, ptr);
            },
            __w3_load_env: function (ptr) {
                if (state.env) {
                    buffer_1.writeBytes(state.env, memory.buffer, ptr);
                }
            },
            __w3_sanitize_env_args: function (ptr) {
                if (!state.sanitizeEnv.args) {
                    abort("__w3_sanitize_env: args is not set");
                    return;
                }
                buffer_1.writeBytes(state.sanitizeEnv.args, memory.buffer, ptr);
            },
            __w3_sanitize_env_result: function (ptr, len) {
                state.sanitizeEnv.result = buffer_1.readBytes(memory.buffer, ptr, len);
            },
            __w3_abort: function (msgPtr, msgLen, filePtr, fileLen, line, column) {
                var msg = buffer_1.readString(memory.buffer, msgPtr, msgLen);
                var file = buffer_1.readString(memory.buffer, filePtr, fileLen);
                abort("__w3_abort: " + msg + "\nFile: " + file + "\nLocation: [" + line + "," + column + "]");
            },
        },
        env: {
            memory: memory,
        },
    };
};
//# sourceMappingURL=imports.js.map